import { CALL_API } from "../../../middlewares/api";

export const REST_REPAYMENT_FETCH_REQUEST = "REST_REPAYMENT_FETCH_REQUEST";
export const REST_REPAYMENT_FETCH_SUCCESS = "REST_REPAYMENT_FETCH_SUCCESS";
export const REST_REPAYMENT_FETCH_ERROR = "REST_REPAYMENT_FETCH_ERROR";

export function get_loans_for_rest_repayment() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/for-rest-repayment",
      authenticatedRequest: true,
      types: [
        REST_REPAYMENT_FETCH_REQUEST,
        REST_REPAYMENT_FETCH_SUCCESS,
        REST_REPAYMENT_FETCH_ERROR,
      ],
    },
  };
}

export const MAKE_REST_REPAYMENT_REQUEST = "MAKE_REST_REPAYMENT_REQUEST";
export const MAKE_REST_REPAYMENT_SUCCESS = "MAKE_REST_REPAYMENT_SUCCESS";
export const MAKE_REST_REPAYMENT_ERROR = "MAKE_REST_REPAYMENT_ERROR";

export function rest_repay_loan(LoanId, callback) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/fundorders/make-rest-repayment",
      authenticatedRequest: true,
      method: "POST",
      data: { LoanId },
      types: [
        MAKE_REST_REPAYMENT_REQUEST,
        { method: success_action.bind(this, LoanId, callback) },
        MAKE_REST_REPAYMENT_ERROR,
      ],
    },
  };
}

function success_action(LoanId, callback, response) {
  return (dispatch) => {
    dispatch({
      type: MAKE_REST_REPAYMENT_SUCCESS,
      response,
      dataSent: { LoanId },
    });

    callback();
  };
}
